import { render } from "./ModalSuccess.vue?vue&type=template&id=2a89d217&scoped=true"
import script from "./ModalSuccess.vue?vue&type=script&lang=js"
export * from "./ModalSuccess.vue?vue&type=script&lang=js"

import "./ModalSuccess.vue?vue&type=style&index=0&id=2a89d217&scoped=true&lang=css"

import exportComponent from "C:\\projeto\\dynamik\\dynamik_webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a89d217"]])

export default __exports__